
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import dashboard_api from "../api/protected/dashboard";

const CheckEmailVerification = ({ children, allowDashboard = false }) => {
    const [loading, setLoading] = useState(true);
    const [isVerified, setIsVerified] = useState(null);

    useEffect(() => {
        const checkVerification = async () => {
            try {
                const resp = await dashboard_api.getValidateEmail();
                setIsVerified(resp.data === 1); // 1 = verified
            } catch (err) {
                console.error("Verification check failed", err);
                setIsVerified(false);
            } finally {
                setLoading(false);
            }
        };
        checkVerification();
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }

    // if not verified AND not dashboard, bounce to /verify
    if (!isVerified && !allowDashboard) {
        return <Navigate to="/verify?unverified=true" replace />;
    }

    return children;
};

export default CheckEmailVerification;
